module.exports = __webpack_public_path__ + "media/icons/facebook-2-0188926e.png";